import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const Ga4PropertyStreamPickerScreen = lazy(
  () => import('~/features/onboarding/pages/ga4-property-stream-picker-screen'),
);

/** `connectionId` is passed through from the connect step (after OAuth
 *  callback or successful paste-mode validate) so this route can stand alone
 *  — no cross-screen zustand coordination required. */
const searchSchema = z.object({
  connectionId: z.string(),
});

/** Named component wrapper so the `react-hooks/rules-of-hooks` lint
 *  recognizes `Route.useSearch()` as being called inside a component. */
function Ga4PickPropertyRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Ga4PropertyStreamPickerScreen connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics/pick-property',
)({
  validateSearch: searchSchema,
  component: Ga4PickPropertyRouteComponent,
});
